import { Component } from '@angular/core';
import { IconComponent } from '@shared/icon/icon.component';

interface FAQ {
  question: string;
  answer: string;
  expanded: boolean;
}

interface Section {
  title: string;
  items: FAQ[];
}

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  imports: [IconComponent],
})
export class FaqComponent {
  currentCategory: string = 'general';

  general: FAQ[] = [
    {
      question: 'Can you tell me more about SkinBet?',
      answer: `SkinBet has been around since late 2017, we first found success with PUBG, then we moved on to be the largest VGO-VIRL Project until OPSkins moved on from the project. We changed the System to work with Crypto Deposits and Withdraws, which you can still find now! We're a reputable Team with a long clean History, our Biggest Achievement is Being the FIRST Provably Fair PVP Site in our Community since 2018. We're the first site that used a 3rd Party API to generate the Winning Tickets to make sure our Gamemodes can't be tempered with.`,
      expanded: false,
    },
  ];

  jackpot: FAQ[] = [
    {
      question: 'How does Jackpot work?',
      answer: `SkinBet's new Jackpot works with Rust skins - either from your Steam Inventory or your On-Site Backpack. To wager your Steam skins, make sure you save your Trade URL and you have Mobile Authentication Enabled on Steam. You can also wager Skins directly from your Backpack - You can Deposit or do Surveys for free to get a Balance on site to buy Backpack Skins with, or you can Deposit your Own Skins to your Backpack!`,
      expanded: false,
    },
    {
      question: 'What are the Limitations on Jackpot?',
      answer: `Each Jackpot has it's own limitations, you should see it on the Jackpot page itself. Usually there's a limited Skins you can wager and some Jackpots may have a Maximum value. Deposits aren't accepted in the last few seconds of a Jackpot to make sure our Provably Fair system is rock solid.`,
      expanded: false,
    },
    {
      question: 'Where do I get my winnings? Steam? Backpack?',
      answer: `You can choose where to receive your Winnings on your Profile. We have a very flexible system with three options:
      - First, you get the Skin where it was Deposited from. So if there's 2 Steam Skins and 1 Backpack Skin, you get a Trade Offer with 2 Steam Skins and you get a Backpack Skin in your SkinBet Backpack.
      - Our Second option is for users who prefer Steam, in this case everything you win goes to your Steam Inventory, which means you get a Trade Offer for 2 Steam Skins and then you get a second Trade Offer for the Backpack Skin (based on the example in the First option).
      - Our Last option is for Backpack users, everything goes to your Backpack, you don't have to do anything. You are free to do whatever you want with your skins.`,
      expanded: false,
    },
    {
      question: 'Can I Team up with other users on Jackpot?',
      answer: `We won't stop you, but we won't hold the other person reliable if they don't keep up their end of the deal.`,
      expanded: false,
    },
    {
      question: 'My winnings are missing, how can I get my Skins?',
      answer: `Since Jackpot and Coinflip both rely on a 3rd Party API (Steam), errors may come up on their end that prevent your winnings from being delivered on time. Don't worry about it, you have ~24 hours to go to your History and resend any lost Winnings and Withdraws. After 24 hours you have to make a ticket to get your winnings. After 14 days, we are not required to issue any refunds, so make sure you reach out in time.`,
      expanded: false,
    },
  ];

  coinflip: FAQ[] = [
    {
      question: 'How does Coinflip work?',
      answer: `SkinBet's new Coinflip works with Rust skins - either from your Steam Inventory or your On-Site Backpack. To wager your Steam skins, make sure you save your Trade URL and you have Mobile Authentication Enabled on Steam. You can also wager Skins directly from your Backpack - You can Deposit or do Surveys for free to get a Balance on site to buy Backpack Skins with, or you can Deposit your Own Skins to your Backpack!`,
      expanded: false,
    },
    {
      question: 'What are the Limitations on Coinflip?',
      answer: `It largely depends on the Coinflip you are trying to join. When users Host their lobby, they can determine a % range in which users have to stay in to wager against them. For example if someone Hosts a Lobby for $10 with a 10% range, users can join with Skins ranged from $9-$11 and your Chances of Winning will be determined by your wager.`,
      expanded: false,
    },
    {
      question: 'Where do I get my winnings? Steam? Backpack?',
      answer: `You can choose where to receive your Winnings on your Profile. We have a very flexible system with three options:
      - First, you get the Skin where it was Deposited from. So if there's 2 Steam Skins and 1 Backpack Skin, you get a Trade Offer with 2 Steam Skins and you get a Backpack Skin in your SkinBet Backpack.
      - Our Second option is for users who prefer Steam, in this case everything you win goes to your Steam Inventory, which means you get a Trade Offer for 2 Steam Skins and then you get a second Trade Offer for the Backpack Skin (based on the example in the First option).
      - Our Last option is for Backpack users, everything goes to your Backpack, you don't have to do anything. You are free to do whatever you want with your skins.`,
      expanded: false,
    },
    {
      question: 'How does Steve work?',
      answer: `Steve has been our Mascot since forever and he's our Bot you can Call to Join your Coinflips. If Steve has enough Skins within Joining Range, Steve will attempt to join your Coinflip several times. If for some reason Steve can't join you can always Wager against other users.`,
      expanded: false,
    },
    {
      question: 'My winnings are missing, how can I get my Skins?',
      answer: `Since Jackpot and Coinflip both rely on a 3rd Party API (Steam), errors may come up on their end that prevent your winnings from being delivered on time. Don't worry about it, you have ~24 hours to go to your History and resend any lost Winnings and Withdraws. After 24 hours you have to make a ticket to get your winnings. After 14 days, we are not required to issue any refunds, so make sure you reach out in time.`,
      expanded: false,
    },
  ];

  depositWithdraws: FAQ[] = [
    {
      question: 'How can I Deposit to SkinBet?',
      answer: `It's pretty simple, you click the Wallet Icon and then the Deposit Button: This will show you all of the available options you can Deposit with. We currently accept Rust Skins through Steam, TF2 Pure Skins through Steam, CSGO & DOTA Skins through SkinsBack, BTC, ETH and LTC and Credit Card deposits. You can use any of these to get a Balance on site which you can wager on our Games or spend on Skins on our Rust Store. You can also Directly Deposit your Skins to the Backpack. Oh, you can also do Surveys for FREE or use Promo Codes but more on that a bit later!`,
      expanded: false,
    },
    {
      question: 'Are there any Deposit Bonuses?',
      answer: `Of course! We pay a Deposit Bonus on every method, but first you must use a Partner Code on the Affiliate Page. Both you and the user Referring you will get a Bonus on every Deposit made. You also get a LARGE Deposit Bonus on 3rd Party Deposit Methods, so expect a much larger bonus when using CC, Crypto or SkinsBack.`,
      expanded: false,
    },
    {
      question: 'Is there a way to make money for free?',
      answer: `Obviously, there's always been a way to earn Free Balance by completing Surveys or by using Promo Codes created by our Staff or anyone on site!`,
      expanded: false,
    },
    {
      question: `What should I do if I wasn't Credited for a Deposit?`,
      answer: `First, always be patient because it might take some time to verify the legitimacy of your Deposit in some cases, but if you believe you haven't been Credited for a Deposit, make a ticket! Make sure to include as many details as possible, the Trade Offer Hash for Steam Deposits or the Unique Deposit ID of the 3rd Party Service you used, or the TXN Hash for Crypto Deposits. We won't just give you the balance, we'll also patch any errors we can that may cause these issues to happen.`,
      expanded: false,
    },
    {
      question: 'Do I have to Wager before withdrawing?',
      answer: `Yes, why else would you Deposit for? We require users to Wager a certain % of their Deposit to make sure nobody is abusing our Affiliate & Rewards system.`,
      expanded: false,
    },
    {
      question: 'What Withdraw Methods are available?',
      answer: `You can Withdraw Rust skins from your Backpack or the Rust Store easily, or if you've Deposited through a 3rd Party then Crypto Withdrawals should be available for you.`,
      expanded: false,
    },
    {
      question: 'Are there any fees on Withdraws?',
      answer: `Yes and no, basically we put a very minimal fee on Store Skins (standard practice everywhere) to stop Affiliate Abusers and Traders from exploiting the Affiliate & Rewards System.`,
      expanded: false,
    },
    {
      question: `I'm having trouble with a Withdraw, how can I get help?`,
      answer: `Since we use 3rd Party API's to handle our Withdraws, errors may happen - reach out to us (make a ticket) and we'll help you out. Please beware, we cannot refund any Crypto Withdraws sent to the wrong address! If it's a Rust Withdraw, you can most likely resend it easily from your Withdraw History. Try that a few times before you make a ticket!`,
      expanded: false,
    },
  ];

  affiliatesBonuses: FAQ[] = [
    {
      question: 'Can I earn money with SkinBet?',
      answer: `Yes and it's easier than ever - we completely reworked our Affiliate System for SkinBet V4 and we offer more than we used to. You can simply Save your Code on the Affiliates page and Share it with the world - you will get rewards from anyone Depositing and Wagering under your Code - you can see more about this on the Affiliates page.`,
      expanded: false,
    },
    {
      question: 'Are there any bonuses for the Users I bring?',
      answer: `Yes, they also get more money when they Deposit to their SkinBet wallet!`,
      expanded: false,
    },
    {
      question: `What's SkinBet's new Reward System like?`,
      answer: `You can find more information about the Rewards on the Rewards Page - We pay out much better Cashbacks than before and we also kept the Faucet. Oh, and we still have our Weekly Leaderboards!`,
      expanded: false,
    },
    {
      question: 'What are the Basic Requirements to Earn Money with Rewards?',
      answer: `We put several requirements in place to make sure our legitimate users receive most of the rewards and not bots and multi accounts - because of this, we have a standard SkinBet Level requirement, a small Wager requirement and you must be in our Discord or you must Follow our Twitter and verify this on the page.`,
      expanded: false,
    },
    {
      question: 'How does the Faucet work?',
      answer: `The New Faucet pays you much more frequently - instead of every 48 hours, you get a small balance every 15 minutes. There's a Daily Limit which you can see on the Popup itself.`,
      expanded: false,
    },
    {
      question: 'How can I Earn Cashbacks?',
      answer: `Cashbacks can be accumulated by Wagering and being bested by your Opponents. We check how much you Deposited the past 30 Days when calculating the amount you get - once you reach $5 you can Claim your Cashback easily.`,
      expanded: false,
    },
    {
      question: 'Is it Raining?',
      answer: `Hopefully it's only Raining on SkinBet - in this case any user who's wagered recently can participate - users will be paid out after the timer ends, the higher levels will get the most reward. Anyone can Make it Rain, the Button for it is above the Chat!`,
      expanded: false,
    },
    {
      question: 'How can I make Trivias & Trivia Rains?',
      answer: `Trivias and Trivia Rains can be created by just about anyone - you click the Cogwheel on the top left of the Chat - the creator must Specify the Reward, the Question and the Answer. It's very easy to get Trivia Banned, so make sure you don't fool around, stick to SFW topics, don't break the site's and chat's rules and use common sense as these Trivia Bans are rarely reversible - they also stop you from entering Trivias. For Trivia Rains, you have to give 3 wrong answers and 1 right answer, the money is split between users who answered correctly. Some limitations may apply when you're trying to answer a Trivia, so make sure you've Wagered Recently.`,
      expanded: false,
    },
    {
      question: 'Supply Drops and how they work',
      answer: `As you Wager on SkinBet, the Supply Drop's Box will get filled more and more. Once it's full, a Supply Drop will happen within ~30 minutes. Make sure you've Wagered Recently to be able to enter and have SkinBet.GG in your Steam Name as well. The higher level you are, the more you'll earn from the Standard Supply Drop. MegaDrops can be Created by Admins, almost anyone can Join for a fixed reward.`,
      expanded: false,
    },
    {
      question: 'Leaderboards',
      answer: `Each Week we pay a large amount to our Top Wagering users - to earn Points in our Leaderboards, make sure you Wager on a Raked PVP Gamemode or any House Game. Payments are paid out in On-Site balance.`,
      expanded: false,
    },
    {
      question: 'How can I claim my commission?',
      answer: `Once you reach $5 in Affiliate Balance, you can Claim it on the Affiliate page and Withdraw it immediately. No wagering required, but you may need to have Active Referrals as well before you can Withdraw. Active Referrals are Users Depositing on your Code in the past 30 days.`,
      expanded: false,
    },
    {
      question: 'Can I create my own Promo Code?',
      answer: `Yes, you can creat your own Promo Code on the Affiliates page - you can also apply a lot of restrictions to it to make sure it goes to the right people.`,
      expanded: false,
    },
    {
      question: 'Someone took my code?',
      answer: `If you're a streamer or just someone known in the community, you can just ask us to recover your code, make a ticket!`,
      expanded: false,
    },
  ];

  other: FAQ[] = [
    {
      question: `What's this Backpack System on the right?`,
      answer: `If it bothers you, feel free to close it. You can enjoy SkinBet without ever touching the Backpack System if you prefer the old-school experience, but why would you? The BP System makes Wagering so much easier, you can Wager on Jackpot and Coinflip without having to mess around with Steam - no mobile confirmations, no Trade Window Popups, nothing! You can choose to receive your Skin Winnings on your Backpack, on Steam or Both with ease!`,
      expanded: false,
    },
    {
      question: 'Is SkinBet Provably Fair?',
      answer: `Would anyone really answer No to this question and expect to run a stable project? Yes, we are the FIRST Provably Fair PVP Site since 2018. I'm not saying we changed the world, but if it wasn't for us it would have taken a big drama or two for some other project to add it. As soon as we saw the opportunity we implemented that System, set the standard in our Community and it's been a better place since then. All our Gamemodes generate a Seed which we display as a Hash before Bets are even accepted - then once Bets are Closed we reach out to Random.ORG for a second Seed, we combine this two and use a code to generate the winning Ticket. You can read up more on this on our PF Page.`,
      expanded: false,
    },
    {
      question: 'Do you offer Bug Bounties?',
      answer: `Yes, if you find any function that can cause serious harm report it and we'll pay you in Crypto as we fix the issue. We've done this a few times in the past. In some cases, when we specifically ask for it on Twitter or Discord, you can also get paid for reporting other "smaller" bugs, but generally don't expect a bounty for those - only Site-breaking, Balance abusing bugs come with an immediate bounty.`,
      expanded: false,
    },
    {
      question: 'Sponsorships',
      answer: `Our Team will reach out to you if we're interested in Sponsoring you, please only reach out to us if we're actively looking for sponsors. Our email for that is sponsorships@skinbet.gg`,
      expanded: false,
    },
    {
      question: 'House Edge',
      answer: `Everywhere, on every other site, all Games Operate with a House Edge - this allows us to keep the service up and running - pay our Staff, etc.
      - Jackpot and PVP Coinflip don't technically have a "House Edge" as your Odds are based on how much you Wager, but yes, we do take a certain cut, but ONLY from your Winnings - and that's how we give you your Deposit Bonuses, Cashbacks, Supply Drops, Leaderboards and much more in return. We call it "Rake" on PVP Gamemodes, and it's between 5-8% , it depends on your Level and wether you're a Verified Member (Twitter-Disc) with SkinBet.GG in your Steam Name.      - Steve Coinflips do not have a House Edge, Steve joins with a fair percentage and we Rake up to 10% on his losses.`,
      expanded: false,
    },
  ];

  sections: Section[] = [
    { title: 'General Section', items: this.general },
    { title: 'Jackpot', items: this.jackpot },
    { title: 'Coinflip', items: this.coinflip },
    { title: 'Depositing and Withdrawing', items: this.depositWithdraws },
    { title: 'Affiliates & Rewards & Bonuses', items: this.affiliatesBonuses },
    { title: 'Other', items: this.other },
  ];

  toggleAccordion(item: FAQ) {
    item.expanded = !item.expanded;
  }

  changeCategory(category: string) {
    this.currentCategory = category;
  }

  get currentCategoryInfo(): any {
    switch (this.currentCategory) {
      case 'general':
        return [...this.general, ...this.depositWithdraws];
      case 'jackpot':
        return this.jackpot;
      case 'coinflip':
        return this.coinflip;
      case 'plinko':
        return null;
      case 'case-battles':
        return null;
      case 'affiliates':
        return this.affiliatesBonuses;
      default:
        return null;
    }
  }
}
